/**
 * Mock result generator. When the backend isn't reachable (or for local dev),
 * picks a random winning ball number within the variant's range.
 */
import type { BallVariant } from '../types/game';

export class MockResultSource {
  pickWinner(variant: BallVariant): number {
    return Math.floor(Math.random() * variant.ballCount) + 1;
  }

  fakeResult(variant: BallVariant, betLines: { betItemId: number; amount: number }[]) {
    const ballNumber = this.pickWinner(variant);
    let totalWinLose = 0;
    const betResults = betLines.map((b) => {
      const def = variant.bets.find((x) => x.id === b.betItemId);
      const isWin = !!def && def.winsOn.includes(ballNumber);
      const winLose = isWin ? Math.round(b.amount * (def!.payout - 1)) : -b.amount;
      totalWinLose += winLose;
      return { betItemId: b.betItemId, betAmount: b.amount, winLose, isWin };
    });
    return {
      result: `n${ballNumber}`,
      ballNumber,
      totalWinLose,
      afterBalance: -1, // signal: caller fills in
      nextRoundId: 'mock-' + Math.random().toString(36).slice(2, 8),
      betResults,
      positiveWinAmount: betResults.reduce((a, r) => a + Math.max(0, r.winLose), 0),
      hasPositiveWin: betResults.some((r) => r.winLose > 0),
    };
  }
}
